import { Icon, IconButton, Menu, MenuItem } from "@mui/material";
import React, { FC, useState } from "react";
import { Filter } from "src/framework/commons/FilterUtil";
import { FieldFilter } from "src/framework/store/DataGridStore";
import { InputDateTime, InputDateTimeProperties } from "../InputDateTime";


export interface InputDateTimeFilterProperties extends InputDateTimeProperties {
    fieldFilter: FieldFilter,
    filter: Filter;
    onChangeValue: (filter: Filter) => void;
}

const InputDateTimeFilter: FC<InputDateTimeFilterProperties> = ({
    fieldFilter,
    filter,
    onChangeValue,
    label = "",
    fullWidth = true
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedCriteriaState, setSelectedCriteriaState] = useState<string>((fieldFilter.criteriaList[0].text || "="));
    const [selectedIndexState, setSelectedIndexState] = useState<number>(0);
    const [filterState, setFilterState] = useState<Filter>({ ...filter, criteria: (fieldFilter.criteriaList[0].value || undefined) });

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        const _filter: Filter = { ...filterState }
        const s = fieldFilter.criteriaList[index];
        setSelectedCriteriaState(s.text);
        setSelectedIndexState(index)
        _filter.criteria = s.value || undefined
        setFilterState(_filter)

        onChangeValue(_filter)
        setAnchorEl(null);
    }

    const handleClose = (): void => {
        setAnchorEl(null);
    }

    return <InputDateTime
        fullWidth
        label={label}
        name={filter.field}
        value={filter.value}
        onChange={(date: string | null) => {
            const _filter: Filter = { ...filterState }
            _filter.value = date
            setFilterState(_filter);
            onChangeValue(_filter)
        }}
        prefix={
            <>
                <div style={{ color: "#50788A", backgroundColor: "#e0e0e0", /* border: "1px solid #00a335", */ minWidth: "30px", borderRadius: "4px" }}>{selectedCriteriaState}</div>
                <IconButton size="small" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                    <Icon>arrow_drop_down</Icon>
                </IconButton>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}

                >

                    {fieldFilter.criteriaList.map((c, index: number) => {
                        return (
                            <MenuItem
                                selected={selectedIndexState === index}
                                onClick={(event) => handleMenuItemClick(event, index)}
                            >
                                {c.text}
                            </MenuItem>
                        )
                    })}
                </Menu>
            </>
        }
    />
}


export { InputDateTimeFilter }